/*
   * Рассчитываем длину и время пути
   */
export default function (pointFirst, pointSecond) {
  const deltaX = Math.abs(pointFirst.clientX - pointSecond.clientX);
  const deltaY = Math.abs(pointFirst.clientY - pointSecond.clientY);
  const deltaTime = pointSecond.timeStamp - pointFirst.timeStamp;

  const hypotenuse = Math.sqrt((deltaX ** 2) + (deltaY ** 2));

  return { hypotenuse, deltaTime };
}



// WEBPACK FOOTER //
// ./src/lib/tools/getHypotenuse.js